import { type TranslationTree } from '@/i18n/types';

export const messages = {
  invalidLink: 'Link Inválido',
  invalidLinkBody: 'O link de redefinição de senha é inválido ou expirou.',
  backToSignIn: 'Voltar ao Login',
  resettingFor: 'Redefinindo senha para: ',
  send: 'Enviar',
  rememberedPassword: 'Lembrou da senha? ',
  signIn: 'Fazer Login',
  done: 'Senha redefinida com sucesso',
  title: 'Redefinir Senha',
  newPassword: 'Nova Senha',
  confirmPassword: 'Confirmar Nova Senha',
  error: 'Não foi possível redefinir a senha, tente novamente',
} satisfies TranslationTree;
